import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";

export const module: ModuleOptions = {
  resource: ResourceEnum.Carrier,
  smallIcon: <i className="icon-15-shipment" />,
  bigIcon: <i className="icon-20-shipment" />,
};
